__turbopack_context__.v({
  "className": "halant_dd93318f-module__u7Ku5q__className",
  "variable": "halant_dd93318f-module__u7Ku5q__variable",
});
